/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import mbpUtil from 'mbp-api-util';

export default (mbpUtil.getEnv('APP_VERSION_ENV') === 'uat1' || mbpUtil.getEnv('APP_VERSION_ENV') === 'uat2') ? 'development' : 'production';
